import axiosInstance from "../helpers/axiosInstance"

export const assignPickingTaskPickers = async (pickingOrderId, pickerIds) => {
    const res = await axiosInstance.post(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-tasks/assign-pickers`,
        { picking_order_id: pickingOrderId, picker_ids: pickerIds }
    )
    return res.data
}

export const fetchPickingTasksSummary = async (orderId) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-tasks/order/${orderId}/summary`
    )
    return res.data
}

export const reassignPickingTask = async (taskId, newPickerId) => {
    const res = await axiosInstance.put(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-tasks/${taskId}/reassign`,
        { new_picker_id: newPickerId }
    )
    return res.data
}

export const assignTasksBulk = async (pickingOrderId, assignments) => {
    const res = await axiosInstance.post(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/${pickingOrderId}/assign-tasks-bulk`,
        { assignments }
    )
    return res.data
}

export const unassignPickingTask = async (taskId) => {
    const res = await axiosInstance.put(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-tasks/${taskId}/unassign`
    )
    return res.data
}

export const fetchPickerQueue = async (pickerId) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/pickers/${pickerId}/queue`
    )
    return res.data
}

export const updatePickerQueue = async (pickerId, queue) => {
    const res = await axiosInstance.patch(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/pickers/${pickerId}/queue`,
        { queue }
    )
    return res.data
}

export const fetchPickingStatus = async (pickingOrderId) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/${pickingOrderId}/picking-status`
    )
    return res.data
}

export const fetchPickingTasksToBreak = async (params) => {
    const res = await axiosInstance.get(
        `${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-tasks/to-break`,
        { params }
    )
    return res.data
}
